var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.diseaseName)?_c('div',{staticClass:"western-medicine-disease-name"},[_c('Tooltip',{attrs:{"content":_vm.diseaseName,"placement":"bottom-start"}},[_c('span',{staticClass:"text"},[_vm._v("("),_c('span',{staticClass:"text-body"},[_vm._v(_vm._s(_vm.diseaseName))]),_vm._v(")")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }